// React Basic and Bootstrap
import React, { Component } from "react";
import { Row, Col } from "reactstrap";
import { Link } from "react-router-dom";

//import images
import computer from "../../images/hosting/dominio.png";
import hosting from "../../images/hosting/hosting.png";
import diseno from "../../images/hosting/diseno.png";

import shapeLight from "../../images/shapes/shape-light.png";

class Services extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    return (
      <React.Fragment>
        <section className="section">
          <div className="container">
            <Row className="align-items-center mb-4">
              <Col lg={9} md={8} className="text-sm-left">
                <div className="section-title">
                  <h4 className="main-title mb-4">Servicios</h4>
                  <p className="text-muted para-desc mb-0">
                    Comienza a trabajar con{" "}
                    <span className="text-danger font-weight-bold">
                      DeveloCat
                    </span>{" "}
                    y te guiarémos en todo lo que tu sitio web necesita de
                    inicio a fin.
                  </p>
                </div>
              </Col>

              <Col
                lg={3}
                md={4}
                className="mt-4 mt-sm-0 text-sm-right pt-2 pt-sm-0"
              >
                {/*<Link to="/desarrollo-web" className="btn btn-outline-warning">
                  Ver más <i className="mdi mdi-chevron-right"></i>
    </Link>*/}
              </Col>
            </Row>

            <Row>
              <Col lg={4} md={6} className="col-12 mt-5 pt-3">
                <div className="features">
                  <div className="image position-relative d-inline-block">
                    <img src={computer} alt="dominio" />
                  </div>

                  <div className="content mt-4">
                    <h4 className="title-2">Nombre de Dominio</h4>
                    <p className="text-muted">
                      El nombre de tu sitio web es una parte fundamental del
                      proceso. Si aún no lo tienes claro, te asesoramos como
                      parte del desarrollo
                    </p>
                  </div>
                </div>
              </Col>

              <Col lg={4} md={6} className="col-12 mt-5 pt-3">
                <div className="features">
                  <div className="image position-relative d-inline-block">
                    <img src={hosting} alt="hosting" />
                  </div>

                  <div className="content mt-4">
                    <h4 className="title-2">Web Hosting</h4>
                    <p className="text-muted">
                      Dependiendo del target al que quieras llegar,
                      seleccionamos un hosting que aproveche el máximo de tu
                      potencial
                    </p>
                  </div>
                </div>
              </Col>

              <Col lg={4} md={6} className="col-12 mt-5 pt-3">
                <div className="features">
                  <div className="image position-relative d-inline-block">
                    <img src={diseno} alt="diseño web" />
                  </div>

                  <div className="content mt-4">
                    <h4 className="title-2">Diseño Web</h4>
                    <p className="text-muted">
                      Si no sabes qué es lo que necesitas, nosotros te ayudamos
                      a encontrar la mejor opción para tu empresa
                    </p>
                  </div>
                </div>
              </Col>
            </Row>
          </div>

          <div className="container-fluid">
            <Row>
              <div className="home-shape-bottom">
                <img
                  src={shapeLight}
                  alt=""
                  className="img-fluid mx-auto d-block"
                />
              </div>
            </Row>
          </div>
        </section>
      </React.Fragment>
    );
  }
}

export default Services;
